/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      country
      firstName
      middleName
      lastName
      secondLastName
      email
      phone
      fullAddress
      phones
      avatar
      photos
      idType
      idNumber
      preference {
        id
        dashboardLanguage
        emailsLanguage
        supportLanguage
        subscribedToCompanyNews
        subscribedToTradingNews
        createdAt
        updatedAt
      }
      selectedAccount {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      accounts {
        items {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        nextToken
      }
      transactions {
        items {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        country
        firstName
        middleName
        lastName
        secondLastName
        email
        phone
        fullAddress
        phones
        avatar
        photos
        idType
        idNumber
        preference {
          id
          dashboardLanguage
          emailsLanguage
          supportLanguage
          subscribedToCompanyNews
          subscribedToTradingNews
          createdAt
          updatedAt
        }
        selectedAccount {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        accounts {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPreference = /* GraphQL */ `
  query GetPreference($id: ID!) {
    getPreference(id: $id) {
      id
      dashboardLanguage
      emailsLanguage
      supportLanguage
      subscribedToCompanyNews
      subscribedToTradingNews
      createdAt
      updatedAt
    }
  }
`;
export const listPreferences = /* GraphQL */ `
  query ListPreferences(
    $filter: ModelPreferenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPreferences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dashboardLanguage
        emailsLanguage
        supportLanguage
        subscribedToCompanyNews
        subscribedToTradingNews
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      userID
      createdAt
      updatedAt
      name
      number
      type
      status
      currency
      username
      balance
      equity
      margin
      freeMargin
      marginLevel
      transactions {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getAccountTransactions = /* GraphQL */ `
  query GetAccountTransactions($id: ID!) {
    getAccountTransactions(id: $id) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      account {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAccountTransactionss = /* GraphQL */ `
  query ListAccountTransactionss(
    $filter: ModelAccountTransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccountTransactionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      id
      userID
      type
      status
      currency
      sourceAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      targetAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      methodName
      methodTransactionID
      value
      createdAt
      updatedAt
      persisted
      history {
        items {
          id
          createdAt
          status
          resourceType
          resourceID
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions(
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getTransactionHistory = /* GraphQL */ `
  query GetTransactionHistory($id: ID!) {
    getTransactionHistory(id: $id) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      createdAt
      status
      resourceType
      resourceID
      updatedAt
    }
  }
`;
export const listTransactionHistorys = /* GraphQL */ `
  query ListTransactionHistorys(
    $filter: ModelTransactionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        createdAt
        status
        resourceType
        resourceID
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContactRequest = /* GraphQL */ `
  query GetContactRequest($id: ID!) {
    getContactRequest(id: $id) {
      id
      userID
      firstName
      lastName
      phone
      email
      supportLanguage
      country
      preferences
      callMeASAP
      createdAt
      updatedAt
    }
  }
`;
export const listContactRequests = /* GraphQL */ `
  query ListContactRequests(
    $filter: ModelContactRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        firstName
        lastName
        phone
        email
        supportLanguage
        country
        preferences
        callMeASAP
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        country
        firstName
        middleName
        lastName
        secondLastName
        email
        phone
        fullAddress
        phones
        avatar
        photos
        idType
        idNumber
        preference {
          id
          dashboardLanguage
          emailsLanguage
          supportLanguage
          subscribedToCompanyNews
          subscribedToTradingNews
          createdAt
          updatedAt
        }
        selectedAccount {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        accounts {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const transactionsByDate = /* GraphQL */ `
  query TransactionsByDate(
    $userID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsByDate(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      nextToken
    }
  }
`;
